<template>
  <RInput
    :model="model"
    :parentPath="parentPath"
    :meta="meta"
    :comboIdKeys="['smartTerminalId']"
    :hasCol="hasCol"
    :value="value"
    name="smartTerminalId"
    rComponentName="RAutocomplete"
    @update-value="updateValue"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import _get from 'lodash/get';
import { createMetaRow } from '@/lib/metaUtils';
import RInput from '@/components/core/common/RInput.vue';

export default {
  components: {
    RInput,
  },

  props: {
    model: {
      type: Object,
      required: true,
    },
    parentPath: {
      type: String,
      default: 'record',
    },
    hasCol: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      meta: {},
      smartTerminalWatcher: null,
    };
  },

  created() {
    const hasSite = this.$store.getters['auth/loggedInSiteId'];
    this.meta = createMetaRow('Card Reader', 'string', hasSite ? { dataprovider: 'smartterminals' } : {});

    if (!hasSite) {
      this.$store.dispatch('notify/push',
        {
          title: 'Please log in again.',
          text: 'Your login site is unspecified so site-related data cannot be determined.',
        });
    }

    if (this.selectedSmartTerminal) this.updateSmartTermial();
    else this.setSmartTerminalWatcher();
  },

  computed: {
    value() {
      return _get(this, 'model.smartTerminalId', null) || this.selectedSmartTerminal;
    },

    ...mapGetters({
      selectedSmartTerminal: 'auth/selectedSmartTerminal',
    }),
  },

  methods: {
    updateValue(payload) {
      if (this.selectedSmartTerminal !== payload.value) {
        this.$store.dispatch('auth/setSmartTerminal', payload.value);
      }

      this.$emit('update-value', payload);
      this.smartTerminalWatcher = null;
    },

    updateSmartTermial() {
      this.updateValue({
        key: 'smartTerminalId',
        value: this.selectedSmartTerminal,
        path: this.parentPath,
        userInitiated: false,
      });
    },

    setSmartTerminalWatcher() {
      this.smartTerminalWatcher = this.$watch('selectedSmartTerminal', () => {
        this.updateSmartTermial();
      });
    },
  },
};
</script>
